import Enum from '@/utils/Enum';

const AlertTypeEnum = {
	SUCCESS: new Enum(0, 'success'),
	ERROR: new Enum(1, 'error'),
	INFO: new Enum(2, 'info'),
};

export default AlertTypeEnum;